import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60Trophy2 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 48 48'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M39.000,14.332 L39.000,20.889 C39.000,20.908 38.990,20.925 38.989,20.944 C38.990,20.963 39.000,20.980 39.000,20.999 C39.000,28.934 32.805,35.431 25.000,35.949 L25.000,46.000 L35.000,46.000 C35.553,46.000 36.000,46.447 36.000,46.999 C36.000,47.551 35.553,48.000 35.000,48.000 L13.000,48.000 C12.447,48.000 12.000,47.551 12.000,46.999 C12.000,46.447 12.447,46.000 13.000,46.000 L23.000,46.000 L23.000,35.949 C15.195,35.431 9.000,28.934 9.000,20.999 C9.000,20.980 9.010,20.963 9.011,20.944 C9.010,20.925 9.000,20.908 9.000,20.889 L9.000,14.332 C3.932,14.332 0.000,8.778 0.000,3.999 C0.000,3.447 0.447,3.000 1.000,3.000 L9.000,3.000 L9.000,0.999 C9.000,0.447 9.447,-0.001 10.000,-0.001 L38.000,-0.001 C38.553,-0.001 39.000,0.447 39.000,0.999 L39.000,3.000 L47.000,3.000 C47.553,3.000 48.000,3.447 48.000,3.999 C48.000,8.778 44.068,14.332 39.000,14.332 ZM9.000,5.000 L2.069,5.000 C2.549,8.533 5.460,12.333 9.000,12.333 L9.000,5.000 ZM37.000,20.889 L37.000,2.000 L11.000,2.000 L11.000,20.889 C11.000,20.908 10.990,20.925 10.989,20.944 C10.990,20.963 11.000,20.980 11.000,20.999 C11.000,28.168 16.832,33.999 24.000,33.999 C31.168,33.999 37.000,28.168 37.000,20.999 C37.000,20.980 37.010,20.963 37.011,20.944 C37.010,20.925 37.000,20.908 37.000,20.889 ZM39.000,5.000 L39.000,12.333 C42.540,12.333 45.451,8.533 45.931,5.000 L39.000,5.000 ZM27.000,25.999 L21.000,25.999 C20.447,25.999 20.000,25.552 20.000,25.000 C20.000,24.448 20.447,23.999 21.000,23.999 L23.000,23.999 L23.000,13.414 L20.707,15.707 C20.316,16.097 19.684,16.097 19.293,15.707 C18.902,15.316 18.902,14.683 19.293,14.293 L23.293,10.293 C23.579,10.005 24.009,9.921 24.383,10.076 C24.757,10.231 25.000,10.595 25.000,11.000 L25.000,23.999 L27.000,23.999 C27.553,23.999 28.000,24.448 28.000,25.000 C28.000,25.552 27.553,25.999 27.000,25.999 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60Trophy2.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
